var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCornerDrag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 8 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3766",
    transform: "rotate(90 4 4)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 3799",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(6 3)"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 3820",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(3)"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 3831",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(6 6)"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 3830",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(6)"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 3829",
    cx: 1,
    cy: 1,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 3832",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(3 3)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCornerDrag);
export default __webpack_public_path__ + "static/media/CornerDrag.2f23d671.svg";
export { ForwardRef as ReactComponent };